import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@google/model-viewer';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Change this from unregister() to register() to enable PWA installation!
serviceWorkerRegistration.register();